<sub-nav [menu]="menu"></sub-nav>
<div class="subnav-padding"></div>
<div class="container-fluid">
  <router-outlet></router-outlet>
</div>
